import { EmptyBox } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import TasksWidgetDashboard from '../TasksWidgetDashboard/TasksWidgetDashboard';

type TasksDashboardWidgetProps = {
    formalistIds: number[];
};

const WIDGET_KEYS = ['formalite', 'tiers', 'utilisateur'] as const;

const TasksDashboardWidget: React.FunctionComponent<TasksDashboardWidgetProps> = function ({
    formalistIds,
}) {
    const [taskCounts, setTaskCounts] = useState<Record<string, number>>({});
    const loadedRef = useRef<Set<string>>(new Set());

    const handleTasksLoaded = useCallback(
        (key: string) => (count: number) => {
            loadedRef.current.add(key);
            setTaskCounts((prev) => ({ ...prev, [key]: count }));
        },
        [],
    );

    const allLoaded = WIDGET_KEYS.every((k) => loadedRef.current.has(k));
    const allEmpty = allLoaded && WIDGET_KEYS.every((k) => (taskCounts[k] ?? 0) === 0);

    return (
        <Box
            sx={{
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '100%',
                py: 2,
                px: 1,
            }}
        >
            <TasksWidgetDashboard
                title="Tâches dossier"
                filters={{
                    userIds: formalistIds,
                    tacheIsDone: false,
                }}
                apiTarget="formalite"
                onTasksLoaded={handleTasksLoaded('formalite')}
            />
            <TasksWidgetDashboard
                title="Tâches prescripteur"
                filters={{
                    userIds: formalistIds,
                    tacheIsDone: false,
                }}
                apiTarget="tiers"
                onTasksLoaded={handleTasksLoaded('tiers')}
            />
            <TasksWidgetDashboard
                title="Mes tâches"
                filters={{ userIds: formalistIds, tacheIsDone: false }}
                apiTarget="utilisateur"
                onTasksLoaded={handleTasksLoaded('utilisateur')}
            />
            {allEmpty && <EmptyBox text="Pas de tâches à afficher" />}
        </Box>
    );
};

export default TasksDashboardWidget;
